import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { TrademeCoreUiModule } from '@classifieds-sell/trademe-core-ui';
import { PropertyRentalAttributeSectionComponent } from './property-rental-attribute-section.component';
import { TgInputModule, TgSelectModule } from '@trademe/tangram';
import { DraftValidationModule } from '@classifieds-sell/shared';

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        TrademeCoreUiModule,
        TgSelectModule,
        TgInputModule,
        DraftValidationModule
    ],
    declarations: [PropertyRentalAttributeSectionComponent],
    exports: [PropertyRentalAttributeSectionComponent]
})
export class PropertyRentalAttributeSectionModule {}
